export default function irregularExamples() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr>
          <th>
            <em>infinitive</em>
          </th>
          <td> dati </td>
          <td> jesti </td>
          <td> věděti </td>
        </tr>
        <tr>
          <th>
            <em>present-tense stem</em>
          </th>
          <td>
            <b>da-</b>
          </td>
          <td>
            <b>je-</b>
          </td>
          <td>
            <b>vě-</b>
          </td>
        </tr>
        <tr>
          <th> ja </th>
          <td> dam </td>
          <td> jem </td>
          <td> věm </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> daš </td>
          <td> ješ </td>
          <td> věš </td>
        </tr>
        <tr>
          <th> on/ona/ono </th>
          <td> da </td>
          <td> je </td>
          <td> vě </td>
        </tr>
        <tr>
          <th> my </th>
          <td> damo </td>
          <td> jemo </td>
          <td> věmo </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> date </td>
          <td> jeste </td>
          <td> věte </td>
        </tr>
        <tr>
          <th> oni </th>
          <td> dadut </td>
          <td> jedut </td>
          <td> vědut </td>
        </tr>
      </tbody>
    </table>
  )
}
